import React from 'react';
import { UserCircleIcon } from '@heroicons/react/20/solid';
import { getLinkRootDomain } from '../helpers/functions';

interface LinkedinViewProps {
  link: string,
}

export default function LinkedinPreview(props: LinkedinViewProps) {

  const { link } = props;

  const url = link.match(/^http[s]?:\/\//) ? link : `http://${link}`;

  return (
    <a
      target="_blank"
      href={url}
      rel="noreferrer"
      className="flex flex-row shadow-md rounded-lg mt-1 p-2"
    >

      <div
        className="shrink-0 height-fit-content bg-transparent mr-4 text-gray-400 rounded-full ring-8 ring-offset-0 ring-main-50 focus:outline-none m-2 "
      >
        <span className="sr-only">
          Go to LinkedIn
        </span>
        <UserCircleIcon className="h-6 w-6 text-main-600 bg-main-25" />
      </div>
      <div>
        <p className="text-main-600 text-xs">
          LinkedIn Profile
        </p>
        <p className="text-base font-semibold">LinkedIn</p>
      </div>
    </a>
  );
}
